import React, { useEffect, useState } from 'react'
// import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input } from 'reactstrap'
import Modals from '../modal'
import { ImgTag } from '../HtmlComp'
import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input, FormGroup, InputGroup, InputGroupAddon, Spinner } from 'reactstrap'
import AccordionForm from '../accordion/AccordionForm'
import Select from 'react-select'
import Flatpickr from 'react-flatpickr'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import testModeImg from '../../../assets/images/manual/10.png'
import liveModeImg from '../../../assets/images/manual/11.png'
import img12 from '../../../assets/images/manual/12.png'
import img13 from '../../../assets/images/manual/12.png'
import img14 from '../../../assets/images/manual/12.png'
import successImg from '../../../assets/images/manual/success_msg.png'
import stopped from '../../../assets/images/manual/success_msg.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import angleLogo from '../../../assets/images/manual/angleLogo.png'
import { useDispatch, useSelector } from 'react-redux'
import {SellTrick, SwitchToLive, linkAngelOne, setLoader, setTrackParam, startTrick, stopTrick } from '../../pages/Home/store'
import classNames from 'classnames'
import { selectThemeColors } from '../../../utility/Utils'
import { Trash,Info,Percent } from 'react-feather'
// import * as Icon from 'react-feather'
import { addTrick, setSelect, setTrickDetailLoader } from '../TricksDetails/store'
import FileUploaderSingle from '../../forms/form-elements/file-uploader/FileUploaderSingle'
import TooltipControlled from '../tooltips/TooltipControlled'
import robovideo from './video/robovideo.mp4'

export const handleDecimal = (e,inputType) => {
  const keyCode = e.keyCode || e.which;
  const keyValue = String.fromCharCode(keyCode);

  switch (inputType) {
    case 'percent':
        if (!/^[0-9.]$/.test(keyValue) && keyCode !== 8) {
          e.preventDefault();
        }

        if (keyValue === '.' && e.target.value.includes('.')) {
          e.preventDefault();
        }
      break;

    case 'number':
      if (!/^[0-9]+$/.test(keyValue)) {
        e.preventDefault();
      }
      break;
      
    default:
      break;
  }
  
};

export const FormComp = ({setPayload,Success, setSuccess ,toggle}) => {
  const dispatch = useDispatch()
  const {
    reset,
    control,
    setError,
    setValue,
    register,
    handleSubmit,
    getValues,
    trigger,
    formState: { errors }
  } = useForm({})

  const { TrickDetail, error, trickDetailLoader, selected, status } = useSelector((store) => store?.TrickDetail)
  
  
  const [leveCount, setLeveCount] = useState()
  const [currentLevel, setCurrentLevel] = useState(0)
  const [buttonName, setButtonName] = useState('Add')
  const [columnsCount, setColumnsCount] = useState([])
  const [active, setActive] = useState(false)
  const [stopLoss, setStopLoss] = useState(false)
  const setMyActiveMode = (data) => {
    setActive(!active)
  }


  const handleDiscard = () => {
    // debugger
    reset()
    // setIsEdit(false)
    dispatch(setSelect(null))
    dispatch(setLoader(false))
      toggle()
  }

  const onSubmit = (data) => {
    data.FirstEntryBuyQuantity = 1
    // console.log('fdd',data)
    const filteredData = Object.keys(data).filter(key => data[key] !== undefined).reduce((obj, key) => {
      obj[key] = data[key];
      return obj;
    }, {});

    //  console.log('fdd',filteredData);
    //  return false
    
    const output = {
      Status:0,
      CycleMode: active ? 0 : 1,
      // SL: stopLoss ? 0 : 1,
      FirstEntryBuyQuantity: filteredData?.FirstEntryBuyQuantity,
      BuyingNoOfLevel: filteredData?.BuyingNoOfLevel,
      TakeprofitPercent: filteredData?.TakeprofitPercent,
      SellProfitPriceBounceBackFromPeak: filteredData?.SellProfitPriceBounceBackFromPeak,
      BuyPriceFromLowBounceBack: filteredData?.BuyPriceFromLowBounceBack,
      SubPositionTakeProfitCallBack: filteredData?.SubPositionTakeProfitCallBack ?? 0,
      stopLossPercentage: filteredData?.stopLossPercentage ?? 0,
      Dips: [],
      SubDips: []
    };
    
    
    for (const key in filteredData) {
      if (key.startsWith("Times")) {
        const i = key.substring(5);
        output.Dips.push({
          Level: i,
          Times: filteredData[`Times${i}`],
          Percentage: filteredData[`Percentage${i}`]
        });
    
      i > 4 && output.SubDips.push({
        Level: i,
        Percent: filteredData[`Percent${i}`]
        });
      }
    } 
    
     if(!Object.values(output).includes(undefined)) {
      setSuccess('1')
    setPayload({...output,url:buttonName === 'Add'? "addtrick" : "updatetrick" })
    dispatch(setSelect(null))
    // reset()
  }
  }

 

  useEffect(() => {
  //  console.log('das',getValues())
    let columnsCountArr =[]

    for (let i = 0; i < leveCount; i++) {
      columnsCountArr.push({
        quantity:`Times${i+1}`,
        quantityPlaceholder:`Quantity ${i+1}`,
        level:`level`,
        levelPlaceholder:`level ${i+1}`,
        percent:`Percentage${i+1}`,
        percentPlaceholder:`Level ${i+1}`,
        quantityVal:getValues(`Times${i+1}`) ?? 0,
      }) 
    }

    setColumnsCount(columnsCountArr)

  }, [leveCount])

  const handleInputChange = (index, event) => {
    const { value } = event.target;

    const updatedData = [...columnsCount];

    // Update the 'name' field of the object at the specified index
    updatedData[index] = {
      ...updatedData[index],
      quantityVal: value
    };

    // Update the state with the modified data
    setColumnsCount(updatedData);
  };

  // useEffect(() => {
    
  //   register("BuyingNoOfLevel", { required: true,min:{
  //     value:{currentLevel},
  //     message:'Buying - No of Level can not be less then current limit'
  //   } });
    
  // }, [currentLevel]);

  useEffect(() => {
    if (selected) {
      setButtonName("Edit")      
      setCurrentLevel(TrickDetail?.bynoofLevel)      
      setValue('Status', selected.Status)
      setValue('CycleMode', selected.CycleMode)
      setActive(selected.CycleMode===0 ? true : false)
      setStopLoss(selected?.SL===0 ? false : true)
      setValue('FirstEntryBuyQuantity', selected.FirstEntryBuyQuantity)
      setValue('BuyingNoOfLevel', selected.BuyingNoOfLevel)
      setValue('TakeprofitPercent', selected.TakeprofitPercent)
      setValue('SellProfitPriceBounceBackFromPeak', selected.SellProfitPriceBounceBackFromPeak)
      setValue('BuyPriceFromLowBounceBack', selected.BuyPriceFromLowBounceBack)
      setValue('SubPositionTakeProfitCallBack', selected.SubPositionTakeProfitCallBack)

      for (let i = 0; i <= selected?.dipsList?.length; i++) {
        setValue(`Times${i+1}`, selected?.dipsList[i]?.Times)
        setValue(`Percentage${i+1}`, selected?.dipsList[i]?.Percentage)
      }
      for (let i = 0; i < selected?.subdipsList?.length; i++) {
        setValue(`Percent${i+5}`, selected?.subdipsList[i]?.Percent)
      }
      // console.log('bfrsetlvl',selected?.BuyingNoOfLevel)
      setLeveCount(selected?.BuyingNoOfLevel)
    }
  }, [])


   
  const form2 = <>
  <>
  {/* {JSON.stringify(columnsCount)} */}
  
  

{/* {(() => {
  let total = 0;
  for (var i=0; i<columnsCount.length; i++) {
      total += parseInt(columnsCount[i].quantityVal);
  }

  return <>------------------{total}</>

})()} */}

  </>
    <Row>
      {
        columnsCount?.map(({percent,percentPlaceholder,quantity,quantityPlaceholder},i)=><>
          <Col style={{display:'hidden'}} sm="6" key={percentPlaceholder} className="mb-1" display="flex">
            <Label className="form-label" for={percent}>
              {percentPlaceholder}
            </Label>
            <Controller
              name={percent}
              control={control}
              {...register(percent, {
                required: `Please Enter ${percent}`
              })}
              render={({ field }) => (
                <InputGroup>
                  <Input          
                    placeholder=''
                    id={percent}
                    invalid={errors[percent] && true}
                    {...field}
              onKeyPress={(e)=>handleDecimal(e,'percent')}
              />
                  <span className="input-group-text">
                      <Percent size={14}/>
                  </span>
                </InputGroup>
              )}
            />
            {errors && errors[percent] && (
              <small className='text-danger' >{errors[percent].message}</small >
            )}

          </Col>
          <Col sm="6" key={i} className="mb-1" display="flex">
            <Label className="form-label" for={quantity}>
              {quantityPlaceholder}
            </Label>
            <Controller
              name={quantity}
              control={control}
              {...register(quantity, {
                required: `Please Enter ${quantity}`
              })}
              render={({ field }) => (
                <InputGroup>
                  <Input
                    placeholder=''
                    id={quantity}
                    invalid={errors[quantity] && true}
                    {...field}
                    onKeyUp={(e)=> handleInputChange(i,e)}
              onKeyPress={(e)=>handleDecimal(e,'number')}
              />
                  {/* <span className="input-group-text">
                    Times
                  </span> */}
                </InputGroup>
              )}
            />
            {errors && errors[quantity] && (
              <small className='text-danger' >{errors[quantity].message}</small >
            )}

          </Col>
        </>)      
      }      
    </Row>
  </>


let columnsCount2 =[]

for (let i = 0; i < leveCount; i++) {
  (i+1) > 4 && columnsCount2?.push({Percent:`Percent${i+1}`,PercentPlaceholder:`${i+1} Sub-Percent`}) 
}
  const form3 = <>
    <Row>
    {
        columnsCount2?.map(({PercentPlaceholder,Percent},i)=><>
          <Col sm="12" key={PercentPlaceholder} className="mb-1" display="flex">
          <Label className="form-label" for={Percent}>
            {PercentPlaceholder}
          </Label>
          <Controller
            name={Percent}
            control={control}
            {...register(Percent, {
              required: `Please Enter ${Percent}`
            })}
            render={({ field }) => (
              <InputGroup>
                <Input
                         
                placeholder={`Enter ${PercentPlaceholder}`}
                  id={Percent}
                  invalid={errors[Percent] && true}
                  {...field}
              onKeyPress={(e)=>handleDecimal(e,'percent')}
              />
                <span className="input-group-text">
                    <Percent size={14}/>
                </span>
              </InputGroup>
            )}
          />
          {errors && errors[Percent] && (
            <small className='text-danger' >{errors[Percent].message}</small >
          )}

          </Col>
        </>)      
      }      
    </Row>
  </>

  return (
    <Form onSubmit={handleSubmit((data) => onSubmit(data, 'Add'))}>
      <>
      <div className='amountNeeded'> 
        <label>Amount Needed: {TrickDetail?.LTP*columnsCount.reduce((sum, item) => sum + parseInt(item.quantityVal), 0)} </label> 

         {/* {(() => {
            let dipsdt = []
              for (const key in getValues()) {
                if (key.startsWith("Times")) {
                  const i = key.substring(5);
                  dipsdt.push(getValues(`Times${i}`));
                }
              }
              console.log('dasdadasd',dipsdt)
        })()} */}
      </div>
        <div className='cycleOneShot switchWrapper'>
         
        <TooltipControlled targetId="page1Tooltip1" tooltipContent="When enabled, the bot will continuously engage in buying and selling activities."/>
        <label for='CycleMode'><b>Cycle</b></label>
          <FormGroup switch className='p-0 formSwitch'>
          <Input
          id='CycleMode'
          name='CycleMode'
            type="switch"
            className='mx-1'
            checked={active}
            onClick={setMyActiveMode}
          />
        <label for='CycleMode'><b>One Shot</b></label>
        <TooltipControlled targetId="page1Tooltip2" tooltipContent="This option makes the bot work until it reaches the predefined profit target. After achieving the set profit, the bot will stop making any further purchases."/>
        </FormGroup>
        </div>
        {/* Stop loss start 
        <div className='stopLossGropWrap'>
          <div className='stopLossWrap'>
            <label for="stopLoss"> <h4>Stop Loss <TooltipControlled targetId="page1Tooltip14" tooltipContent="Stop Loss."/></h4></label>
            <FormGroup switch className='p-0 formSwitch'>
              <Input
              id='stopLoss'
              name='SL'
                type="switch"
                className='mx-1'
                checked={stopLoss}
                onClick={(e) => setStopLoss(!stopLoss)}
              />
            </FormGroup>
            
          </div>
            {stopLoss===true &&
              <div className='stopLossPercentageWrap mt-2'>
              <Label className="form-label" for="FirstEntryBuyQuantity">
                Stop Loss Percentage <TooltipControlled targetId="page1Tooltip15" tooltipContent="Stop Loss percentage" />
              </Label>
              <Controller
                name="stopLossPercentage"
                control={control}
                {...register('stopLossPercentage', {
                  required: 'Stop Loss required'
                })}
                render={({ field }) => (
                  <InputGroup>
                  <Input
                            
                    placeholder="Stop loss %"
                    id="stopLossPercentage"
                    invalid={errors.FirstEntryBuyQuantity && true}
                    {...field}                                    
                    onKeyPress={(e)=>handleDecimal(e,'number')}
                  />
                  <span className="input-group-text">
                      <Percent size={14}/>
                  </span>
                  </InputGroup>
                )}
              />
              {errors && errors.stopLossPercentage && (
                <small className='text-danger' >{errors.stopLossPercentage.message}</small >
              )}
              </div>
            }
        </div>
        Stop loss end */}
      </>
      <Row >
        <Col sm="6" className="mb-1 hidden" display="flex">
          <Label className="form-label" for="FirstEntryBuyQuantity">
            First Buy-in Quantity <TooltipControlled targetId="page1Tooltip3" tooltipContent="This represents the initial stock purchased when the robot starts trading. It is calculated based on the reference quantity and the quantity set for the next level." />
          </Label>
          <Controller
            name="FirstEntryBuyQuantity"
            control={control}
            {...register('FirstEntryBuyQuantity', {
              // required: 'Please Enter First Buy-in Quantity'
            })}
            render={({ field }) => (
              <Input
                         
                placeholder="Enter First Buy-in Quantity"
                id="FirstEntryBuyQuantity"
                invalid={errors.FirstEntryBuyQuantity && true}
                {...field}                
                value={1}
                onKeyPress={(e)=>handleDecimal(e,'number')}
              />
            )}
          />
          {errors && errors.FirstEntryBuyQuantity && (
            <small className='text-danger' >{errors.FirstEntryBuyQuantity.message}</small >
          )}
        </Col>
        <Col sm={12} className="mb-1" display="flex">          
          <Label className="form-label" for="BuyingNoOfLevel">
            Buying - No of Level <TooltipControlled targetId="page1Tooltip4" tooltipContent="This parameter defines the number of predetermined purchase levels in the bot. By default, it is set to 7, but you can easily adjust this number." />
          </Label>
          <Controller
            name="BuyingNoOfLevel"
            control={control}
            {...register('BuyingNoOfLevel', {
              required: 'Please Enter Buying - No of Level',
              min:{
                value:currentLevel,
                message:'Buying - No of Level can not be less then current limit'
              }
            })}
            render={({ field }) => (
              <Input
                         
                placeholder="Enter Buying - No of Level"
                id="BuyingNoOfLevel"
                invalid={errors.BuyingNoOfLevel && true}
                {...field}
                onChange={(e) => {
                  field.onChange(e)
                  setLeveCount(e.target.value)
                  trigger('BuyingNoOfLevel')
                }}
                onKeyPress={(e)=>handleDecimal(e,'number')}
              />
            )}
          />          
          {errors && errors.BuyingNoOfLevel && (
            <small className='text-danger' >{errors.BuyingNoOfLevel.message}</small >
          )}
        </Col>
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="TakeprofitPercent">
            Take Profit % <TooltipControlled targetId="page1Tooltip5" tooltipContent="This indicates the target profit percentage for each position when selling the stock. It is advisable to set a conservative value, such as 1.3%, to ensure more reliable results." />
          </Label>
          <Controller
            name="TakeprofitPercent"
            control={control}
            {...register('TakeprofitPercent', {
              required: 'Please Enter Take Profit %'
            })}
            render={({ field }) => (
              <InputGroup>
                <Input
                         
                placeholder="Enter Take Profit %"
                  id="TakeprofitPercent"
                  invalid={errors.TakeprofitPercent && true}
                  {...field}
                onKeyPress={(e)=>handleDecimal(e,'percent')}
                />
                <span className="input-group-text">
                    <Percent size={14}/>
                </span>
              </InputGroup>
            )}
          />
          {errors && errors.TakeprofitPercent && (
            <small className='text-danger'>{errors.TakeprofitPercent.message}</small>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="SellProfitPriceBounceBackFromPeak">
            Sell Profit Price Bounce Back From Peak % <TooltipControlled targetId="page1Tooltip6" tooltipContent="Bounce Back from Peak: This setting introduces a margin of error when closing a transaction. For example, with a profit margin set at 1.3%, the bot will close positions and sales within a profit range from 1% to 1.3%, optimizing earnings." />
          </Label>
          <Controller
            name="SellProfitPriceBounceBackFromPeak"
            control={control}
            {...register('SellProfitPriceBounceBackFromPeak', {
              required: 'Please Enter Take Profit %'
            })}
            render={({ field }) => (
              <InputGroup>
                <Input
                         
                placeholder="Enter Sell Profit Price Bounce Back From Peak"
                  id="SellProfitPriceBounceBackFromPeak"
                  invalid={errors.SellProfitPriceBounceBackFromPeak && true}
                  {...field}
                onKeyPress={(e)=>handleDecimal(e,'percent')}
                />
                <span className="input-group-text">
                    <Percent size={14}/>
                </span>
              </InputGroup>
            )}
          />
          {errors && errors.SellProfitPriceBounceBackFromPeak && (
            <small className='text-danger'>{errors.SellProfitPriceBounceBackFromPeak.message}</small>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="BuyPriceFromLowBounceBack">
            Buy Price From Low Bounce Back % <TooltipControlled targetId="page1Tooltip7" tooltipContent="This percentage margin determines when the bot can proceed with a new purchase after a recent sale. Setting it above 0% prevents immediate repurchase if the stock's value doesn't increase." />
          </Label>
          <Controller
            name="BuyPriceFromLowBounceBack"
            control={control}
            {...register('BuyPriceFromLowBounceBack', {
              required: 'Please Enter Buy price from low bounce back %'
            })}
            render={({ field }) => (
              <InputGroup>
                <Input
                         
                placeholder="Enter Buy price from low bounce back %"
                  id="BuyPriceFromLowBounceBack"
                  invalid={errors.BuyPriceFromLowBounceBack && true}
                  {...field}
                onKeyPress={(e)=>handleDecimal(e,'percent')}
                />
                <span className="input-group-text">
                    <Percent size={14}/>
                </span>
              </InputGroup>
            )}
          />
          {errors && errors.BuyPriceFromLowBounceBack && (
            <small className='text-danger'>{errors.BuyPriceFromLowBounceBack.message}</small>
          )}
        </Col>
        {(leveCount > 4) &&
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="SubPositionTakeProfitCallBack">
            Sub-position Take-profit Callback % <TooltipControlled targetId="page1Tooltip8" tooltipContent="In split position mode, this parameter establishes the required percentage change before the bot initiates a new purchase. It is recommended to set this between 0.2% and 0.5% to optimize profits." />
          </Label>
          <Controller
            name="SubPositionTakeProfitCallBack"
            control={control}
            {...register('SubPositionTakeProfitCallBack', {
              required: (leveCount > 4) ? 'Please Enter Sub-position Take-profit Callback' : false
            })}
            render={({ field }) => (
              <InputGroup>
                <Input
                         
                placeholder="Enter Sub-position Take-profit Callback"
                  id="SubPositionTakeProfitCallBack"
                  invalid={errors.SubPositionTakeProfitCallBack && true}
                  {...field}
                onKeyPress={(e)=>handleDecimal(e,'percent')}
                />
                <span className="input-group-text">
                  <Percent size={14}/>
                </span>
              </InputGroup>
            )}
          />
          {errors && errors.SubPositionTakeProfitCallBack && (
            <small className='text-danger'>{errors.SubPositionTakeProfitCallBack.message}</small>
          )}
        </Col>
        }
        {(leveCount > 0) ? <AccordionForm toggle={leveCount > 0 ? true : false} Form={form2} title='Level of  configuration' isEdit={buttonName==='Edit' ? true : false} /> : '' }
        {(leveCount > 4) ? <AccordionForm toggle={leveCount > 4 ? true : false} Form={form3} title='Set sub position exit levels' isEdit={buttonName==='Edit' ? true : false}  /> : '' }

        <Col xs={12} className="text-center buttonWrapper mt-2">
          <Button className="me-1" color="primary" type="submit">
            {buttonName}
          </Button>
          <Button outline type="reset" onClick={handleDiscard}>
            Discard
          </Button>
        </Col>
      </Row>
    </Form>
  )
}


export const AngleLinkForm = ({ toggle }) => {
  const {
    reset,
    control,
    setError,
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({})
  const dispatch = useDispatch()

  const { angelOne, error, loader, selected } = useSelector((store) => store?.home)

  const [viewApiKey, setviewApiKey] = useState(false)
  const [viewTotp, setviewTotp] = useState(false)
  const [viewMpin, setviewMpin] = useState(false)
  const [viewClientId, setviewClientId] = useState(false)
  const [viewApiPass, setviewApiPass] = useState(false)
  const [checkTerms, setcheckTerms] = useState(false)
  const [checkedBox, setcheckedBox] = useState(false)
  const [displayTerms, setdisplayTerms] = useState(false)


  const isLink = JSON.parse(localStorage.getItem('userData'));
console.log('isLink', isLink?.brokeraccount_status)

  const handleDiscard = () => {
    reset()
    toggle()
  }

  const onSubmit = (data) => {

    // return false;
    toggle()
    // toggle2()
    dispatch(linkAngelOne(data))
    reset()
  }

  useEffect(() => {
    if(angelOne !== null){
console.log('angelOne', angelOne)
setValue('UserName', angelOne?.UserName)
      setValue('Password', angelOne?.Password)
      setValue('SecretKey', angelOne?.SecretKey)
      setValue('TOTPSecretKey', angelOne?.TOTPSecretKey)
      setValue('MPIN', angelOne?.MPIN)

      angelOne?.UserName && setcheckTerms(true)
      angelOne?.UserName && setcheckedBox(true)
    }
  }, [angelOne])
  

  return <>
    <div className='my-2 d-flex justify-content-center anglelogo'>
      <h3>Linking your account to</h3> <ImgTag url={angleLogo} />
    </div>
    <Row tag={Form} onSubmit={handleSubmit((data) => onSubmit(data, 'Add'))}>
      <Col sm="12" className="mb-1" display="flex">
        <Label className="form-label" for="UserName">
          Enter your Angel One CLIENT ID
        </Label>
        <Controller
          name="UserName"
          control={control}
          {...register('UserName', {
            required: 'Please Enter Enter your Angel One CLIENT ID'
          })}
          render={({ field }) => (
            <div class="input-group">
            <Input
              type={viewClientId ? 'text' : 'password'}    
              placeholder="User Name"
              id="UserName"
              invalid={errors.UserName && true}
              {...field}
              onKeyPress={(e)=>handleDecimal(e)}
              />
              <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" onClick={() => setviewClientId(!viewClientId)}>{viewClientId ? 'Hide' : 'View'}</button>
              </div>
            </div>
          )}
        />
        {errors && errors.UserName && (
          <small className='text-danger' >{errors.UserName.message}</small >
        )}
      </Col>

      <Col sm="12" className="mb-1" display="flex">
        <Label className="form-label" for="Password">
        Enter your angel one smart API password
        </Label>
        <Controller
          name="Password"
          control={control}
          {...register('Password', {
            required: 'Please Enter your Angel One Password'
          })}
          render={({ field }) => (
            <div class="input-group">
            <Input
            type={viewApiPass ? 'text' : 'password'}    
              placeholder="Enter your Angel One Password"
              id="Password"
              invalid={errors.Password && true}
              {...field}
            />
             <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" onClick={() => setviewApiPass(!viewApiPass)}>{viewApiPass ? 'Hide' : 'View'}</button>
              </div>
            </div>
          )}
        />
        {errors && errors.Password && (
          <small className='text-danger' >{errors.Password.message}</small >
        )}
      </Col>

      <Col sm="12" className="mb-1" display="flex">
        <Label className="form-label" for="SecretKey">
          Enter your Angel One API Key
          <small className='ml-2 px-2'>
            <a href="https://robotrick.in/assets/angelimages/Angel%20One%20API%20Key.jpeg" target='_blank'> <b>How to find API KEY?</b></a>
          </small>
        </Label>
        <Controller
          name="SecretKey"
          control={control}
          {...register('SecretKey', {
            required: 'Please Enter your Angel One API Key',
            maxLength:{value:8,message:'invalid API Key shoulb be 8 charecter long'},
            minLength:{value:8,message:'invalid API Key shoulb be 8 charecter long'},
          })}
          render={({ field }) => (
            <div class="input-group">
            <Input
            type={viewApiKey ? 'text' : 'password'}      
              placeholder="Enter your Angel One API Key"
              id="SecretKey"
              invalid={errors.SecretKey && true}
              {...field}
              onKeyPress={(e)=>handleDecimal(e,'number')}
            />
             <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" onClick={() => setviewApiKey(!viewApiKey)}>{viewApiKey ? 'Hide' : 'View'}</button>
              </div>
            </div>
          )}
        />
        {errors && errors.SecretKey && (
          <small className='text-danger' >{errors.SecretKey.message}</small >
        )}
      </Col>

      <Col sm="12" className="mb-1" display="flex">
        <Label className="form-label" for="TOTPSecretKey">
          Enter your Angel One TOTP API Key
          <small className='ml-2 px-2'>
            <a href="https://robotrick.in/assets/angelimages/Angel%20One%20TOTP%20API%20Key.jpeg" target='_blank'> <b>How to find TOTP?</b></a>
          </small>
        </Label>
        <Controller
          name="TOTPSecretKey"
          control={control}
          {...register('TOTPSecretKey', {
            required: 'Please Enter your Angel One TOTP API Key',
            maxLength:{value:26,message:'invalid TOTP shoulb be 26 charecter long'},
            minLength:{value:26,message:'invalid TOTP shoulb be 26 charecter long'},
          })}
          render={({ field }) => (
            <div class="input-group">
            <Input
              type={viewTotp ? 'text' : 'password'}
              placeholder="Enter your Angel One TOTP API Key"
              id="TOTPSecretKey"
              invalid={errors.TOTPSecretKey && true}
              {...field}
              onKeyPress={(e)=>handleDecimal(e,'number')}
              />
              <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" onClick={() => setviewTotp(!viewTotp)}>{viewTotp ? 'Hide' : 'View'}</button>
              </div>
              </div>
          )}
        />
        {errors && errors.TOTPSecretKey && (
          <small className='text-danger' >{errors.TOTPSecretKey.message}</small >
        )}
        

        
      </Col>

      <Col sm="12" className="mb-1" display="flex">
        <Label className="form-label" for="MPIN">
          Enter your Angel One MPIN
        </Label>
        <Controller
          name="MPIN"
          control={control}
          {...register('MPIN', {
            required: 'Please Enter your Angel One MPIN'
          })}
          render={({ field }) => (
            <div class="input-group">
            <Input
              type={viewMpin ? 'text' : 'password'}         
              placeholder="Enter your Angel One MPIN"
              id="MPIN"
              invalid={errors.MPIN && true}
              {...field}
              onKeyPress={(e)=>handleDecimal(e,'number')}
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" onClick={() => setviewMpin(!viewMpin)}>{viewMpin ? 'Hide' : 'View'}</button>
              </div>
              </div>
          )}
        />
        {errors && errors.MPIN && (
          <small className='text-danger' >{errors.MPIN.message}</small >
        )}
      </Col>
          
      <label>
          {checkedBox ? <input type='checkbox' checked required /> : <input type='checkbox' required />}
           &nbsp; I confirm that DDPI status is active in my Angel account &nbsp;
          <TooltipControlled targetId="warn1" tooltipContent="What is DDPI? 
DDPI stands for Demat Debit and Pledge Instruction. It's a document that allows a stockbroker to debit securities from a client's demat account and deliver them to the exchange."/>
      </label>
          
      <label>
      {checkedBox ? <input type='checkbox' checked required /> : <input type='checkbox' required />}
           &nbsp; I confirm that I copied the exact API KEY and TOTP as shown from picture &nbsp;
          
      </label>
      {displayTerms &&
        <Col sm="12" className="">
          <div className='termsCOndtionClass'>
            <h2>Terms and conditions agreement</h2>
          <b>User Consent:</b>
          <p>By entering your credentials to link the API with Robotrick, you acknowledge and provide explicit consent for the bot to engage in trading activities on your behalf. This includes executing trades, monitoring market conditions, and accessing relevant account information.</p>

          <b>Password Security:</b>
          <p>Robotrick ensures the highest standards of security for your login credentials. Your passwords will not be transmitted or shared with any third parties. We prioritize the confidentiality of your sensitive information.</p>

          <b>Data Privacy:</b>
          <p>All user data and information provided during API linking are treated with the utmost confidentiality. Robotrick does not disclose, sell, or share user data with external entities.</p>

          <b>Bot Uptime:</b>
          <p>Robotrick guarantees an uptime of 99.99%. However, in the rare event of downtime, especially during market hours, trading activities may be temporarily affected. This could be due to maintenance, technical issues, or server problems with our broker partners.</p>

          <b>Market Risks:</b>
          <p>Users acknowledge that market conditions are dynamic, and unexpected events can lead to downtimes or disruptions. Robotrick is not liable for any missed trading opportunities or financial losses incurred due to downtime or technical issues beyond our control.</p>

          <b>Broker Partner Dependencies:</b>
          <p>Robotrick relies on broker partners to execute trades. Any downtime or service interruption on the broker's end may impact the bot's ability to trade promptly. Users understand and accept the inherent risks associated with broker dependencies.</p>

          <b>Stock Recommendations:</b>
        <p> Robotrick does not recommend or provide advice on specific stocks. As Robotrick is not an official SEBI license holder, users are advised to conduct their own research and make informed decisions. The bot's activities are based on predefined algorithms, and it does not engage in stock analysis or provide financial advice.</p>

          <b>Subscription Charges:</b>
          <p>Subscription charges are determined by the volume of orders executed through bot buying or selling. Goods and Services Tax (GST) will be applicable on these charges.</p>

          <b>User Responsibility:</b>
          <p>Users are responsible for regularly monitoring their linked accounts, reviewing trade activities, and ensuring the accuracy of their credentials. Any suspicious activity or discrepancy should be reported immediately.</p>

          <b>Indemnification:</b>
          <p>Users indemnify Robotrick and its affiliates from any losses, damages, or liabilities arising from the use of the bot's services. This includes, but is not limited to, market fluctuations, technical issues, and disruptions in broker services.</p>

          <p>By proceeding with API linking, you affirm that you have read, understood, and agreed to these terms and conditions. Robotrick reserves the right to update or modify these terms, and users will be notified of any changes.</p>

            <button type='button' className='my-2 btn btn-primary' onClick={() => {
              setcheckTerms(true) 
              setdisplayTerms(false)}}>I Accept</button>
            
            <button type='button' className='my-2 mx-2 btn btn-primary red' onClick={() => {
              setcheckTerms(false) 
              setdisplayTerms(false)}}>I Reject</button>
          </div>
        </Col>
      }
      <label onClick={()=>setdisplayTerms(true)}>
          <input type='checkbox' checked={checkTerms} style={{pointerEvents:'none'}} required />
           &nbsp; I Accept above Tearms & Condtions &nbsp;
          
      </label>

      <Col xs={12} className="text-center buttonWrapper mt-2">
        <Button className="me-1" color="primary" type="submit">
          {(isLink?.brokeraccount_status === "1") ? 'Edit':'Link'}
        </Button>
        <Button outline type="reset" onClick={handleDiscard}>
          Discard
        </Button>

        {/* <a href='https://tinyurl.com/yrtakh3h' target='_blank' className='btn btn-danger' style={{float:'right'}}>
          Create new angel account
        </a> */}
      </Col>
    </Row>
  </>


}


export const Create_Link = ({ toggle, message }) => {
  const [linkWithAngleOne, setLinkWithAngleOne] = useState(false)

  const toggle2 = () => {
    setLinkWithAngleOne(true)

  }
  return (
    <>
      <ModalBody className="text-center">
        {

          linkWithAngleOne ? <AngleLinkForm toggle={toggle} /> :
            <>
              <Col xs={20} className="text-center">
                <Alert color="warning">
                  <h3 className="alert-heading">Warning!</h3>
                  <div className="alert-body">{message}</div>
                </Alert>
              </Col>

              <div className="modalContent mx-1 my-2">
                <p>
                  Hello,You have not yet linked your Angel One (Trading) account.
                  Please Link it before you set up tricks using <strong>Robotrick</strong>
                </p>
                <Button color="primary" onClick={toggle} >
                  <a href="https://tinyurl.com/yrtakh3h" target="_blank" >
                    Create Now
                  </a>
                </Button>


              </div>

              <div className="modalContent mx-1 my-2">
                <p>
                  <>If you don't have an <strong>Angel One</strong> (Trading) account you can now create it for FREE </>
                </p>
                <Button color="danger" onClick={toggle2}>
                  Link Now
                </Button>
              </div>
            </>

        }

      </ModalBody>
    </>
  )
}

export const Subscribtion = ({ toggle, msg,img,note="",buttonName,video=false }) => {
  const navigate = useNavigate()
  const [visible,setVisable] = useState(!video)

  const navigater = ()=>{
    toggle()
    navigate('/my-subscription')
  }
  return (
    <>
      <ModalBody className="text-center">
        {(video && !visible) && 
        <>
          <video width="100%" height="400" controls={true} autoPlay playsinline>
            <source src={robovideo} type="video/mp4" />
          Your browser does not support the video tag.
          </video>
          <Button color="primary" onClick={()=>setVisable(true)}>
            I Accept
          </Button>
          <Button color="" className='mx-2' style={{background:'#f00'}}>
            I Reject
          </Button>
        </>
        }
        {visible &&
          <>
          <Col xs={20} className="text-center">
            {
              img ? <ImgTag className='img-robo-active-modal' url={img} /> : <ImgTag className='img-robo-active-modal' url={img} />
            }
          </Col>

          <div className="modalContent mx-1 my-2">
            <p> {msg} </p>
          </div>

          <div className="modalContent mx-1 my-2">
            
            <p>
              <strong>Note:</strong> {note ? note : <>Please subscribe to the Robotrick platform with a <strong>Life Time </strong> fee of ₹ 5,000/- only.</>}
            </p>

            <Button color="primary" onClick={navigater}>
              {buttonName}
            </Button>
          </div>
          </>
        }
      </ModalBody>
    </>
  )
}

export const SuccessModal = ({ toggle, Success, content }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [type, setType] = useState('')
  const text = ['Trick Successfully added , Next: Please start Trick Live/Test mode to start trading.','Trick Successfully updated , Next: Please start Trick Live/Test mode to start trading.']
  const myNavi = () => {
    toggle?.()
   !text.includes(content) && navigate('/my-tricks')
  }

  const headerDetails = useSelector((store)=>store?.home?.headerDetails)
  const { TrickDetail, error, trickDetailLoader, selected, status } = useSelector((store) => store?.TrickDetail)
  
  const handleMode = async (data) => {
    
    let payload = {}
    if(headerDetails?.trade_subscription === 0 && data == 'LiveMode') {setType( 'TradeSubscription') }  // need to remove ! sign just keep for testing
    else{
      payload = {
        TricksId: TrickDetail?.TricksId,
        isTestModeActive: data === "TestMode" ? 1 : 0,
        Status: 1
      }

      console.log('dta',payload)
      dispatch(setTrackParam(payload))
      setType(data)
      // console.log('dp',response)
      // myNavi()
    }
  }

  return (
    <>
    {type==='' ?
    <div className="success modalImg">
      <ImgTag url={Success=== 'Stopped' ? stopped : successImg} />
      <h1>Success</h1>
      <p>
        {content}
      </p>
      <h1 className='text-danger'>{Success}</h1>

      {text.includes(content) && <div className="d-flex justify-content-center my-2">
        {TrickDetail?.isTestModeActive !== 1 && <Button color="primary" onClick={() => handleMode('TestMode')}>
          Start Test Mode
        </Button> }
        {TrickDetail?.isTestModeActive !== 0 &&<Button color="primary mx-2" onClick={() => handleMode('LiveMode')}>
          Start Live Mode
        </Button>}
      </div>}

      <div className="d-flex justify-content-center">
        <Button color="primary" onClick={myNavi}>
          Close
        </Button>
      </div>

     
    </div> : 
    type==='TestMode' ? <TestMode toggle={toggle} /> : <LiveMode toggle={toggle} />}
     </>
  )
}

export const TestMode = ({ toggle, message }) => {
  const [Success, setSuccess] = useState(false)
   const [payload, setPayload] = useState({})
   const dispatch = useDispatch()
   // const location = useLocation()
 
   const {TrackParam,status,loader,selected} = useSelector((store) => store?.home)
   const handleDiscard = () => {
     dispatch(setLoader(false)); 
     toggle()
     dispatch(setTrackParam(null))
   }
   const toggle2 = async () => {
     await  dispatch(setLoader(true));   
     try {
       const response = await dispatch(startTrick(TrackParam)); 
       if (response.payload.status === 200 && loading === false) {
       }
     } catch (error) {
       console.error('API Error:', error);
       handleDiscard()
     } finally {
     }   
         setSuccess("Test Mode");
     dispatch(setTrackParam(null))
     dispatch(setLoader(false));
   };
 
 
   return (
     <>{Success === 'Test Mode' ?  
       <SuccessModal toggle={toggle} Success={Success} content=' Trick Successfully added and is now in' /> :
       <div className='modalImg'>
       <ImgTag url={liveModeImg} />
       <p>You are running this trick in <strong>Test Mode</strong>.
         This may affect the performance of the trade and overall profits.
       </p>
       <div className="d-flex justify-content-center">
       <Button color="primary" onClick={toggle2}
          disabled={loader}
         >
           {loader ? (
                   <Spinner text="Loading..." color="white" size="sm" />
                 ) : (
                   'Ok, I Understand the Risk'
                 )}          
         </Button>
         <Button className='ms-1' outline onClick={handleDiscard}>
             Discard
         </Button>
       </div>
     </div>
    
     }
     </>
   )
 }

export const LiveMode = ({ toggle, message }) => {
  const { TrickDetail } = useSelector((store) => store?.TrickDetail)
  const [Success, setSuccess] = useState(false)
  const [payload, setPayload] = useState({})
  const dispatch = useDispatch()
  // const location = useLocation()

  const {TrackParam,status,loader,selected} = useSelector((store) => store?.home)
  const handleDiscard = () => {
    dispatch(setLoader(false)); 
    toggle()
    dispatch(setTrackParam(null))
  }

  const toggle2 = async () => {

    if(TrickDetail?.Status === 1 && TrickDetail?.isTestModeActive === 1 ){
      dispatch(setLoader(true));   
     try {
      //  const response = await dispatch(startTrick(TrackParam)); 
       const response = await dispatch(SwitchToLive({TricksId:TrackParam?.TricksId,isTestModeActive:0}))
     } catch (error) {
       console.error('API Error:', error);
       handleDiscard()
     }  
    }
    else{
      dispatch(setLoader(true));   
     try {
       const response = await dispatch(startTrick(TrackParam)); 
     } catch (error) {
       console.error('API Error:', error);
       handleDiscard()
     }  
    }
   
        setSuccess("Live Mode");
    dispatch(setTrackParam(null))
    dispatch(setLoader(false));
  };


  return (
    <>{Success === 'Live Mode' ?  
      <SuccessModal toggle={toggle} Success={Success} content=' Trick Successfully added and is now in' /> :
      <div className='modalImg'>
      <ImgTag url={liveModeImg} />
      <p>You are running this trick in <strong>Live Mode</strong>.
        This may affect the performance of the trade and overall profits.
      </p>
      <div className="d-flex justify-content-center">
      <Button color="primary" onClick={toggle2}
         disabled={loader}
        >
          {loader ? (
                  <Spinner text="Loading..." color="white" size="sm" />
                ) : (
                  'Ok, I Understand the Risk'
                )}          
        </Button>
        <Button className='ms-1' outline onClick={handleDiscard}>
            Discard
        </Button>
      </div>
    </div>
   
    }
    </>
  )
}

export const MyTricksTradeSettings = ({ toggle, message }) => {
  const [Success, setSuccess] = useState('form')
  const [trickTypeUrl, settrickTypeUrl] = useState('')
  const [payload, setPayload] = useState({})
  const dispatch = useDispatch()
  // const location = useLocation()
  console.log('kgt',toggle)

  const {TrickDetail,trickDetailLoader,status,selected,paramData} = useSelector((store) => store?.TrickDetail)
  const handleDiscard = () => {
    dispatch(setTrickDetailLoader(false)); 
    toggle()
  }

  
  const toggle2 = async () => {
    await  dispatch(setTrickDetailLoader(true)); 
    try {
      
      const response = await dispatch(addTrick({paload:{...payload,TickerId:paramData.TickerId,TricksId:paramData.TricksId},url:payload?.url})); 
      if (response.payload.status === 200) {
        setSuccess('AddTrick');
        settrickTypeUrl(payload?.url)
        dispatch(setSelect(null))
      }
    } catch (error) {
      console.error('API Error:', error);
      handleDiscard()
    } finally {
      // dispatch(setLoader(false));
    }
   
  };

  return (
    <>{Success === "1" ? <div className='modalImg'>
      <ImgTag url={img12} />
      <p>
        You have made changes to your <strong>Trade Settings</strong>. This may affect the overall performance of the trade and profits.
      </p>
      <div className="d-flex justify-content-center">
        <Button color="primary" onClick={toggle2}
         disabled={trickDetailLoader}
        >
          {trickDetailLoader ? (
                  <Spinner text="Loading..." color="white" size="sm" />
                ) : (
                  'Ok, I Understand the Risk'
                )}          
        </Button>
        <Button className='ms-1' outline onClick={handleDiscard}>
            Discard
        </Button>
      </div>
    </div> :
     Success === "AddTrick" ? 
     <SuccessModal toggle={toggle} Success={''} content={`Trick Successfully ${(trickTypeUrl==="updatetrick") ? 'updated' : 'added'} , Next: Please start Trick Live/Test mode to start trading.`} />
    : <FormComp setSuccess={setSuccess} Success={Success} toggle={toggle} setPayload={setPayload}/> 
    }
    </>
  )
}


export const MyTricksStopTrick = ({ toggle, message }) => {
  const [Success, setSuccess] = useState(false)
  const [payload, setPayload] = useState({})
  const dispatch = useDispatch()
  // const location = useLocation()

  const {TrackParam,status,loader,selected} = useSelector((store) => store?.home)
  const handleDiscard = () => {
    dispatch(setLoader(false)); 
    toggle()
    dispatch(setTrackParam(null))
  }
  const toggle2 = async () => {
    await  dispatch(setLoader(true));   
    try {
      const response = await dispatch(stopTrick(TrackParam)); 
      if (response.payload.status === 200 && loading === false) {
      }
    } catch (error) {
      console.error('API Error:', error);
      handleDiscard()
    } finally {
      // dispatch(setLoader(false));
    }   
        setSuccess("Stopped");
    dispatch(setLoader(false));
    dispatch(setTrackParam(null))
  };

  return (
    <>{Success === "Stopped" ?
    <SuccessModal toggle={toggle} Success={Success} content='Trick Successfully' /> :
     <div className='modalImg'>
      <ImgTag url={img12} />
      <p>Stopping Trade Settings may affect the overall performance of the trade and overall profits. </p>
      <div className="d-flex justify-content-center">
        <Button color="primary" onClick={toggle2}
         disabled={loader}
        >
          {loader ? (
                  <Spinner text="Loading..." color="white" size="sm" />
                ) : (
                  'Ok, I Understand the Risk'
                )}          
        </Button>
        <Button className='ms-1' outline onClick={handleDiscard}>
            Discard
        </Button>
      </div>
    </div> 
     
     }
    </>
  )
}


export const SellMyTrick = ({ toggle, message }) => {
  const [Success, setSuccess] = useState(false)
  const [payload, setPayload] = useState({})
  const dispatch = useDispatch()
  // const location = useLocation()

  const {TrackParam,status,loader,selected} = useSelector((store) => store?.home)
  const handleDiscard = () => {
    dispatch(setLoader(false)); 
    toggle()
    dispatch(setTrackParam(null))
  }
  const toggle2 = async () => {
    await  dispatch(setLoader(true));   
    try {
      const response = await dispatch(SellTrick(TrackParam)); 
      if (response.payload.status === 200 && loading === false) {
      }
    } catch (error) {
      console.error('API Error:', error);
      handleDiscard()
    } finally {
      // dispatch(setLoader(false));
    }   
        setSuccess("Sell");
    dispatch(setLoader(false));
    dispatch(setTrackParam(null))
  };

  return (
    <>{Success === "Sell" ?
    <SuccessModal toggle={toggle} Success={Success} content='Trick Sold SuccessFully' /> :
     <div className='modalImg'>
      {/* <ImgTag url={img12} /> */}
      <p>Are you sure you want to sell this stock. </p>
      <div className="d-flex justify-content-center">
        <Button color="primary" onClick={toggle2}
         disabled={loader}
        >
          {loader ? (
                  <Spinner text="Loading..." color="white" size="sm" />
                ) : (
                  'Ok'
                )}          
        </Button>
        <Button className='ms-1' outline onClick={handleDiscard}>
            Discard
        </Button>
      </div>
    </div> 
     
     }
    </>
  )
}

